import { useSafeApiCall, useApiClient } from "src/hooks/api";
import { API_PREFIX_PATH } from "src/constants";
import {
  type EmailAutomationRule,
  type CreateEmailAutomationRuleRequest,
  type ListEmailAutomationRulesResponse,
} from "src/vibe-code/rcm-v2/types";

export const useEmailAutomations = () => {
  const { fetchFromApi } = useApiClient();
  const safeApiCall = useSafeApiCall();

  const listRules = async (
    dealerId: string,
  ): Promise<EmailAutomationRule[]> => {
    try {
      const response = await safeApiCall(
        () =>
          fetchFromApi(
            `${API_PREFIX_PATH}/dealers/${dealerId}/email-automation-rules`,
          ),
        { suppressErrorRedirect: true },
      );
      const data = response as ListEmailAutomationRulesResponse;
      return data.rules || [];
    } catch (error) {
      console.error("Error fetching email automation rules:", error);
      return [];
    }
  };

  const createRule = async (
    dealerId: string,
    request: CreateEmailAutomationRuleRequest,
  ): Promise<boolean> => {
    try {
      await safeApiCall(
        () =>
          fetchFromApi(
            `${API_PREFIX_PATH}/dealers/${dealerId}/email-automation-rules`,
            {
              method: "POST",
              body: request,
            },
          ),
        {
          suppressErrorRedirect: true,
          useServerErrorAsToast: true,
        },
      );
      return true;
    } catch (error) {
      console.error("Error creating email automation rule:", error);
      return false;
    }
  };

  const deleteRule = async (
    dealerId: string,
    ruleId: string,
  ): Promise<boolean> => {
    try {
      await safeApiCall(
        () =>
          fetchFromApi(
            `${API_PREFIX_PATH}/dealers/${dealerId}/email-automation-rules/${ruleId}`,
            {
              method: "DELETE",
            },
          ),
        {
          suppressErrorRedirect: true,
          useServerErrorAsToast: true,
        },
      );
      return true;
    } catch (error) {
      console.error("Error deleting email automation rule:", error);
      return false;
    }
  };

  return {
    listRules,
    createRule,
    deleteRule,
  };
};
